import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Image from 'images/sucesso.svg';
import { Title, Wrapper } from './styles';
import { FormContainer } from 'styles/global';
import { Link as RouterLink, useParams } from 'react-router-dom';

import BackButton from 'components/BackButton';
import { useAuth } from 'contexts/auth';
import { useTracking } from 'contexts/tracking';
import { AcaoEvento } from 'services/TrackingService';

function Sucesso() {
  const { user } = useAuth();
  const { trackId } = useParams<{ trackId: string | undefined }>()
  const { sendTracking } = useTracking();

  useEffect(() => {
    if (!!user) {
      sendTracking({ trackId, acao: AcaoEvento.DadosNaoLocalizados, cpfCnpj: user.cnpJ_CPF });
    }
  }, []);

  return (
    <FormContainer maxWidth={400}>
      <RouterLink style={{ textDecoration: 'none' }} to="/login">
        <BackButton>Alterar CPF</BackButton>
      </RouterLink>
      <Wrapper>
        <img src={Image} alt="Não tem pendências" />
        <Typography variant="h6" style={{ color: 'white', fontSize: 16 }}>
          Não localizamos nenhuma pendência cadastrada na Bellinati, por favor
          entre em contato conosco para maiores detalhes.
        </Typography>
      </Wrapper>
    </FormContainer>
  );
}

export default Sucesso;
